import React from "react";
import FlooringForms from "../forms";
import { Localize, ModalStandard } from "components/service";
import { TFlooringVariation } from "../helpers/flooring-variation-types-helper";

interface IFlooringVariationInfoFieldProps
{
  variation: TFlooringVariation | undefined;
  variables: Record<string, any>;
}

const FlooringVariationInfoField: React.FC<IFlooringVariationInfoFieldProps> = ({
  variation,
  variables,
}) => (
  <ModalStandard
    width={500}
    extraClass={"modal-form"}
    modalButton={
      <strong style={{ cursor: "pointer" }}>{variation?.title}</strong>
    }
    modalTitle={
      <strong className="modal-title">
        <span className="text">
          <Localize>FORMS.Title_EditPriceVariation</Localize>
        </span>
      </strong>
    }
  >
    <FlooringForms.VariationEdit
      action={() => { }}
      flooringID={variation?.flooring_id ?? ""}
      variation={variation}
      variables={variables}
    />
  </ModalStandard>
);

export default FlooringVariationInfoField;
